import ImageUpload from "@/components/ImageUpload";

// Editor for the global page background image + opacity slider.
export default function GlobalBackground({ imageUrl, opacity, onChange }) {
  const value = imageUrl || "";
  const alpha = typeof opacity === "number" ? opacity : 0.3;

  return (
    <div className="space-y-4">
      <p className="text-xs text-inksoft">Imagen que aparece detrás de toda la invitación con efecto parallax al hacer scroll. Ajusta qué tan visible es con la barra de opacidad.</p>
      <div className="max-w-sm">
        <ImageUpload
          value={value}
          onChange={(url) => onChange({ global_bg_url: url })}
          label="Imagen de fondo global"
          aspect="aspect-video"
          testid="global-bg-upload"
        />
      </div>
      {value && (
        <div>
          <div className="flex items-center justify-between">
            <span className="text-xs tracking-widest uppercase text-inksoft">Opacidad del fondo</span>
            <span className="text-sm text-warmgold font-mono">{Math.round(alpha * 100)}%</span>
          </div>
          <input
            type="range"
            min={0}
            max={100}
            step={5}
            value={Math.round(alpha * 100)}
            onChange={(e) => onChange({ global_bg_opacity: Number(e.target.value) / 100 })}
            className="mt-3 w-full accent-warmgold cursor-pointer"
            data-testid="global-bg-opacity"
          />
          <div className="flex justify-between text-[10px] text-inksoft mt-1">
            <span>Sutil</span>
            <span>Visible</span>
            <span>Protagonista</span>
          </div>
        </div>
      )}
    </div>
  );
}
